import { createContext, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";

export const adminApi = axios.create({ baseURL: API, withCredentials: true });
export const formatErr = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
};

const AuthCtx = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  useEffect(() => {
    adminApi.get("/auth/me").then((r) => setUser(r.data)).catch(async () => {
      try { await adminApi.post("/auth/refresh"); setUser((await adminApi.get("/auth/me")).data); } catch { setUser(false); }
    });
  }, []);
  const login = async (email, password) => setUser((await adminApi.post("/auth/login", { email, password })).data);
  const logout = async () => { await adminApi.post("/auth/logout"); setUser(false); };
  return <AuthCtx.Provider value={{ user, login, logout }}>{children}</AuthCtx.Provider>;
};

export const useAdmin = () => useContext(AuthCtx);

export const RequireAdmin = ({ children }) => {
  const { user } = useAdmin();
  if (user === null) return <div className="flex min-h-screen items-center justify-center bg-[#FAF7F2] text-sm text-[#78716C]">Checking session…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};
